module.exports = __webpack_public_path__ + "img/119.6.2a481612.png";